// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import { classicFormat } from '@/hooks/format/useFormatNumber';

// Components
import { HalfBarChart } from '@/components/composite/Charts/HalfBarChart';

export const postsDistributionConfig = {
    tooltip: 'chart.instagram.posts_distribution_tooltip',
    id: 'posts_distribution',
    margin: {
        left: -35
    },
    orientation: 'horizontal',
    datePickerDoesNotApply: true,
    barSize: 35,
    isStacked: true,
    tickFormatterTranslation: 'chart.time_unit',
    tooltipValueTranslation: 'chart.instagram.posts_distribution_value',
    name: {
        month: 'month',
        week: 'week'
    },
    valueFormat: classicFormat,
    size: SIZE_FULL,
    type: 'chart',
    element: HalfBarChart,
    defaultFilter: 'month',
    color: {},
    valueColors: [
        'aquablue',
        'green',
        'blue',
        'red',
        'yellow',
        'purple',
        'pink',
        'orange',
        'lightaquablue',
        'lightgreen',
        'lightblue',
        'lightred',
        'lightyellow',
        'lightpurple',
        'lightpink',
        'lightorange'
    ],
    filters: {
        month: {
            title: 'chart.instagram.posts_distribution_monthly',
            menu: 'chart.instagram.posts_distribution_filter_monthly'
        },
        week: {
            title: 'chart.instagram.posts_distribution_weekly',
            menu: 'chart.instagram.posts_distribution_filter_weekly'
        }
    }
};
